import * as React from 'react';
// removed import of scss-style
/**
 * Generic navigation dropdown.
 */
const NavDropdown = ({ onChange, options, value }) => {
    const forwardValue = (e) => {
        onChange(e.currentTarget.value);
    };
    return (React.createElement("div", { className: "ReadReportMenuContent ReadReportMenuContentSelect" },
        React.createElement("select", { value: value, className: "ReadReportMenuContentSelect__Select", onChange: forwardValue, children: options.map(value => (React.createElement("option", Object.assign({}, { key: value, value }), value))) })));
};
export default NavDropdown;
